import { Feature, Polygon } from "geojson";
import { AppDispatch } from "../../store";
import config from "../../config";
import { siteContextRequest } from "../../redux/siteContextRequest";
import {
  TranslationMatrix,
  ISRS as IMatrixSrs,
} from "../../react/pages/matrixCalculator/types";

export type ISRS = IMatrixSrs;

export interface IAssumedSrs {
  translationMatrixToIntermediateSrs: TranslationMatrix;
  intermediateSrsEpsg: string;
  intermediateSrsProj4: string;
}

export interface IGlobalSrs {
  epsg: string;
  proj4: string;
  name: string;
}

interface SiteBoundaryProperties {
  isAccurate: boolean;
  updated: string;
}

export type SiteBoundary = Feature<Polygon, SiteBoundaryProperties>;

export interface ISite {
  srs: ISRS;
  boundary: SiteBoundary;
  name: string;
  id: string;
  isImperial: boolean;
  projectActivity: string;
}

export const fetchSite =
  (customerId: string, siteId: string) =>
  async (dispatch: AppDispatch): Promise<ISite> => {
    const { data } = await dispatch(
      siteContextRequest(customerId, siteId, {
        method: "GET",
        url: `${config.endpoints.csuApi}/customers/${customerId}/sites/${siteId}`,
      }),
    );
    return data.site;
  };

export const updateSiteBoundary =
  (customerId: string, siteId: string, updatedBoundary: SiteBoundary) =>
  async (dispatch: AppDispatch): Promise<void> => {
    await dispatch(
      siteContextRequest(customerId, siteId, {
        method: "PUT",
        url: `${config.endpoints.csuApi}/customers/${customerId}/sites/${siteId}/set-boundary`,
        data: {
          boundary: updatedBoundary,
        },
      }),
    );
  };

export const setGlobalSrs =
  (customerId: string, siteId: string, epsg: string) =>
  async (dispatch: AppDispatch) => {
    await dispatch(
      siteContextRequest(customerId, siteId, {
        method: "PUT",
        url: `${config.endpoints.csuApi}/customers/${customerId}/sites/${siteId}/set-global-srs`,
        data: {
          epsg,
        },
      }),
    );
  };

export const setAssumedSrs =
  (
    customerId: string,
    siteId: string,
    intermediateSrsEpsg: string,
    translationMatrixToIntermediateSrs: TranslationMatrix,
  ) =>
  async (dispatch: AppDispatch) => {
    await dispatch(
      siteContextRequest(customerId, siteId, {
        method: "PUT",
        url: `${config.endpoints.csuApi}/customers/${customerId}/sites/${siteId}/set-assumed-srs`,
        data: {
          intermediateSrsEpsg,
          translationMatrixToIntermediateSrs,
        },
      }),
    );
  };
